import React, { FC } from 'react'
import cn from 'classnames'
import { Button } from '@corratech/pylot-ui'
import s from './Tabs.module.scss'

type Props = {
    className?: string
    title: string
    index: number
    setSelectedTab: (index: number) => void
    selectedTab: number
}

const TabTitle: FC<Props> = ({
    className,
    title,
    setSelectedTab,
    index,
    selectedTab
}) => {
    return (
        <li
            className={cn(s['title'], {
                [s.active]: selectedTab === index,
                hidden: !title,
                className
            })}
        >
            <Button
                variant="link"
                onClick={() => setSelectedTab(index)}
                onKeyUp={() => setSelectedTab(index)}
            >
                {title}
            </Button>
        </li>
    )
}

export default TabTitle
